import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function UniqueMechanism() {
  return <section className="py-20 md:py-32 px-6 bg-cream relative overflow-hidden" data-id="element-153">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-154"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-155">
        <FadeIn data-id="element-156">
          <h2 className="font-serif text-3xl md:text-5xl text-charcoal mb-8" data-id="element-157">
            He creado el <br className="hidden md:block" data-id="element-158" />
            <span className="text-sage" data-id="element-159">Método del Mapa de Ruta Familiar</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-160">
          <p className="text-lg md:text-xl text-charcoal leading-relaxed mb-10 max-w-3xl mx-auto" data-id="element-161">
            No es un documento legal denso, es una guía viva y práctica diseñada
            para completarse en bloques de 15 minutos.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-162">
          <div className="inline-block bg-white px-8 py-6 rounded-2xl shadow-warm-lg border border-gold/20 relative" data-id="element-163">
            <div className="absolute -top-3 -left-3 w-6 h-6 bg-terracotta rounded-full opacity-50" data-id="element-164"></div>
            <div className="absolute -bottom-3 -right-3 w-8 h-8 bg-sage rounded-full opacity-50" data-id="element-165"></div>

            <p className="font-serif text-2xl md:text-3xl text-terracotta italic" data-id="element-166">
              Es el "manual de usuario" de su vida.
            </p>
            <p className="text-muted mt-4 max-w-2xl mx-auto" data-id="element-167">
              Escrito en lenguaje sencillo para que cualquier hijo o nieto sepa
              exactamente qué hacer, a quién llamar y dónde encontrar lo
              importante.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}